







































































































































































































































































































// import React, { useState } from "react";
// import { withRouter } from "react-router-dom";
// import {
//   Table,
//   Divider,
//   Popconfirm,
//   Col,
//   Row,
//   Steps,
//   Button,
//   message,
//   Popover,
//   Typography,
// } from "antd";
// import moment from "moment";
// import "./index.less";
// import { InfoCircleOutlined } from "@ant-design/icons";
// import vehicleLogo from "../../../../assets/vehiclelogo.png";
// const { Step } = Steps;
// const { Text } = Typography;
// const EstimateTable = (props) => {
//   const {
//     history,
//     gst,
//     pagination,
//     dataSource,
//     openModal,
//     spinner,
//     modify,
//     deleteData,
//     deleteAccess,
//     printAccess,
//   } = props;


//   const column = [
//     {
//       // title: "Action",
//       render: (data, key) => (
//         <div className="box" style={{ backgroundColor: "white" }} key={1}>
//           <Row key={1}>
//             <Col
//               span={8}
//               style={{
//                 borderRight: "0.1px solid rgba(0, 0, 0, 0.1)",
//                 padding: "1rem",
//               }}
//             >
//               <table>
//                 <thead>
//                   <tr>
//                     <td style={{ textAlign: "right", fontWeight: "bolder" }}>
//                       Estimate No
//                     </td>
//                     <td>:</td>
//                     <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                       {data.estimateNo ? data.estimateNo : ""}
//                     </td>
//                   </tr>
//                   <tr>
//                         <td
//                           style={{ textAlign: "right", fontWeight: "bolder" }}
//                         >
//                           Register No
//                         </td>
//                         <td>:</td>
//                         <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                           {`${data.jobOrder?.vehicle?.registerNo}` ||
//                             "-"}
//                         </td>
//                   </tr>
//                   <tr>
//                     <td style={{ textAlign: "right", fontWeight: "bolder" }}>
//                       Job. No
//                     </td>
//                     <td>:</td>
//                     <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                       {data.jobOrder && data.jobOrder?.jobNo
//                         ? data.jobOrder?.jobNo
//                         : ""}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td style={{ textAlign: "right", fontWeight: "bolder" }}>
//                       Model
//                     </td>
//                     <td>:</td>
//                     <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                       {data.jobOrder && data.jobOrder?.vehicle?.vehicle.modelName
//                         ? `${data.jobOrder?.vehicle.vehicle.modelName} - ${data.jobOrder?.vehicle.vehicle.modelCode}`
//                         : ""}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td style={{ textAlign: "right", fontWeight: "bolder" }}>
//                       ServiceType
//                     </td>
//                     <td>:</td>
//                     <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                       {data.serviceType || "-"}
//                     </td>
//                   </tr>
//                   {
//                     data.serviceType == "Accidental" && (
//                       <tr>
//                         <td
//                           style={{ textAlign: "right", fontWeight: "bolder" }}
//                         >
//                           claim status
//                         </td>
//                         <td>:</td>
//                         <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                           {`${data.claimStatus==true ?"Yes":"No"}` || "-"}
//                         </td>
//                       </tr>
//                     )
//                   }
//                   {data.claimStatus && (
//                     <>
//                       <tr>
//                         <td
//                           style={{ textAlign: "right", fontWeight: "bolder" }}
//                         >
//                           Claim Type
//                         </td>
//                         <td>:</td>
//                         <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                           {data.claimType || "-"}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td
//                           style={{ textAlign: "right", fontWeight: "bolder" }}
//                         >
//                           Insurer
//                         </td>
//                         <td>:</td>
//                         <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                           {data.insurer?.name || "-"}
//                         </td>
//                       </tr>
//                       <tr>
//                         <td
//                           style={{ textAlign: "right", fontWeight: "bolder" }}
//                         >
//                           Surveyor
//                         </td>
//                         <td>:</td>
//                         <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
//                           {`${data.survivor?.name} - ${data.survivor?.contacts?.[0]?.phone}` ||
//                             "-"}
//                         </td>
//                       </tr>
//                     </>
//                   )}
//                 </thead>
//               </table>
//             </Col>
//             <Col span={16}>
//               <div style={{ margin: "1rem" }}>
//                 <Row>
//                   <Col span={10}>
//                     <table>
//                       <thead>
//                         <tr>
//                           <img style={{ width: "170px", height: "120px" }} src={data?.jobOrder?.vehicle?.color?.url? data?.jobOrder?.vehicle?.color?.url:vehicleLogo} alt="" />
//                         </tr>
//                         {/* <tr>
//                                                     <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Kms</td>
//                                                     <td>:</td>
//                                                     <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.kms ? data.kms : "-"}</td>
//                                                 </tr> */}
//                       </thead>
//                     </table>
//                     <Row>
//                       <div
//                         style={{
//                           border: "0.1px solid rgba(0, 0, 0, 0.3)",
//                           borderRight: "1px solid rgba(0, 0, 0, 0.3)",
//                           borderRadius: ".2rem",
//                           margin: ".10rem",
//                           marginTop: "1.3rem",
//                         }}
//                       >
//                         <Row>
//                           <h1
//                             style={{ textAlign: "center", marginTop: ".5rem" }}
//                           >
//                             Status :{data.estimateStatus && data.estimateStatus}
//                           </h1>
//                         </Row>
//                       </div>
//                     </Row>
//                   </Col>
//                   <Col span={14}>
//                     <Row>
//                       <Col span={12}>
//                         <table>
//                           <thead>
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Customer
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                 {data.jobOrder?.customer &&
//                                 data.jobOrder?.customer.name
//                                   ? data.jobOrder?.customer.name
//                                   : ""}
//                               </td>
//                             </tr>
//                             {/* <tr>
//                                                     <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Service Type</td>
//                                                     <td>:</td>
//                                                     <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.serviceType && data.serviceType}</td>
//                                                 </tr> */}
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Mechanic
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                 {data.jobOrder?.mechanic &&
//                                 data.jobOrder?.mechanic.profile
//                                   ? data.jobOrder?.mechanic.profile.employeeName
//                                   : "-"}
//                               </td>
//                             </tr>
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Service No
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                {data.jobOrder?.serviceNo}
//                               </td>
//                             </tr>
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Kms
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                {data.jobOrder?.kms}
//                               </td>
//                             </tr>
//                             {/* <tr>
//                                                             <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Date</td>
//                                                             <td>:</td>
//                                                             <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.createdAt && moment(new Date()).format("DD-MM-YYYY")}</td>
//                                                         </tr> */}
//                           </thead>
//                         </table>
//                       </Col>
//                       <Col span={12}>
//                         <table>
//                           <thead>
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Date
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                 {data.createdAt &&
//                                   moment(new Date()).format("DD-MM-YYYY")}
//                               </td>
//                             </tr>
//                             <tr>
//                               <td
//                                 style={{
//                                   textAlign: "right",
//                                   fontWeight: "bolder",
//                                 }}
//                               >
//                                 Time
//                               </td>
//                               <td>:</td>
//                               <td
//                                 style={{
//                                   textAlign: "left",
//                                   paddingLeft: ".5rem",
//                                 }}
//                               >
//                                 {data.createdAt &&
//                                   new Date().toLocaleTimeString()}
//                               </td>
//                             </tr>
//                           </thead>
//                         </table>
//                       </Col>
//                     </Row>
//                     <div
//                       style={{
//                         border: "0.1px solid rgba(0, 0, 0, 0.3)",
//                         borderRadius: ".2rem",
//                         margin: "3.4rem",
//                         marginTop: "3.0rem",
//                       }}
//                     >
//                       <Row>
//                         <h1 style={{ textAlign: "center", marginTop: ".5rem" }}>
//                           Estimate Amount:
//                           {data.estTotalAmount ? data.estTotalAmount : "-"}{" "}
//                           &nbsp;
//                           <Popover
//                             placement="bottom"
//                             content={
//                               <div>
//                                 {data.labourCharge > 0 && (
//                                   <p>Labour Charge:{data.labourCharge}</p>
//                                 )}
//                                 {data.partCharge > 0 && (
//                                   <p>Part Charge:{data.partCharge}</p>
//                                 )}
//                                 {data.consumableCharge > 0 && (
//                                   <p>Consumable Charge:{data.consumableCharge}</p>
//                                 )}
//                                 {data.cgstAmount && data.sgstAmount && (
//                                   <p>Tax:{data.cgstAmount + data.sgstAmount}</p>
//                                 )}
//                                 {data.totalDiscount > 0 && (
//                                   <p>Discount:{data.totalDiscount}</p>
//                                 )}
//                               </div>
//                             }
//                           >
//                             <InfoCircleOutlined />
//                           </Popover>
//                         </h1>
//                       </Row>
//                     </div>

//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "flex-end",
//                         marginRight: ".5rem",
//                       }}
//                     >
//                       <a
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         href={`/job_status/${data?.jobOrder?.id}`}
//                         className="linkylink"
//                         onClick={(event) => {
//                           event.stopPropagation();
//                         }}
//                       >
//                         Tracking URL
//                       </a>
//                       <Divider type="vertical" />
//                       {modify ? (
//                         data.estimateStatus === "PENDING" && (
//                           <span
//                             onClick={(event) => {
//                               event.stopPropagation();
//                               history.push({
//                                 pathname: `/autoadmin/estimate/${data.id}?edit=true`,
//                                 state: {
//                                   gst: gst,
//                                 },
//                               });
//                             }}
//                             className="linkylink"
//                             style={{ marginRight: "5px" }}
//                           >
//                             Modify
//                           </span>
//                         )
//                       ) : (
//                         <span></span>
//                       )}
//                       <Divider type="vertical" />
//                       {printAccess ? (
//                         data.estimatePdf && (
//                           <a
//                             className="linkylink"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             href={data.estimatePdf}
//                             onClick={(event) => {
//                               event.stopPropagation();
//                             }}
//                           >
//                             Download PDF
//                           </a>
//                         )
//                       ) : (
//                         <span></span>
//                       )}
//                       <Divider type="vertical" />
//                       {deleteAccess ? (
//                         <Popconfirm
//                           title="Do you want to delete this Job Order?"
//                           okText="Yes"
//                           cancelText="No"
//                           onCancel={(event) => {
//                             event.stopPropagation();
//                           }}
//                           onConfirm={(event) => {
//                             event.stopPropagation();
//                             deleteData(data.id);
//                             data.id && data.id;
//                           }}
//                         >
//                           <span
//                             onClick={(event) => event.stopPropagation()}
//                             className="linkylink"
//                           >
//                             Delete
//                           </span>
//                         </Popconfirm>
//                       ) : (
//                         <span></span>
//                       )}
//                       {!modify && !deleteAccess && !printAccess ? (
//                         <Text strong disabled>
//                           No Actions Given
//                         </Text>
//                       ) : (
//                         <span></span>
//                       )}
//                     </div>
//                   </Col>
//                 </Row>
//               </div>
//             </Col>
//           </Row>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <div id="estimate">
//       <Table
//         rowKey={(record) => record.id}
//         pagination={pagination}
//         columns={column}
//         tableLayout="auto"
//         style={{ cursor: "pointer" }}
//         dataSource={dataSource}
//         onRow={(record) => ({
//           onClick: () => {
//             history.push({
//               pathname: `/autoadmin/estimate/${record.id}`,
//               state: {
//                 gst: gst,
//               },
//             });
//           },
//         })}
//         loading={spinner}
//       />
//     </div>
//   );
// };
// export default withRouter(EstimateTable);
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import {
  Table,
  Divider,
  Popconfirm,
  Col,
  Row,
  Steps,
  Button,
  message,
  Popover,
  Typography,
} from "antd";
import moment from "moment";
import "./index.less";
import { InfoCircleOutlined } from "@ant-design/icons";
import vehicleLogo from "../../../../assets/vehiclelogo.png";
import { ENDPOINT } from "../../../../constants";
import { platformApi } from "../../../../api";
import VehicleName from "../../../VehicleName";
const { Step } = Steps;
const { Text } = Typography;
const EstimateTable = (props) => {
  const {
    history,
    gst,
    pagination,
    dataSource,
    openModal,
    spinner,
    modify,
    deleteData,
    deleteAccess,
    printAccess,
  } = props;

  const handleDownloadPDF = (data, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // PDF is always generated fresh on-demand by the backend endpoint.
    window.open(`${ENDPOINT}api/estimate/generatePDF/${data.id}`, "_blank");
  };


  const column = [
    {
      // title: "Action",
      render: (data, key) => (
        <div className="box" style={{ backgroundColor: "white" }} key={1}>
          <Row key={1}>
            <Col
              span={8}
              style={{
                borderRight: "0.1px solid rgba(0, 0, 0, 0.1)",
                padding: "1rem",
              }}
            >
              <table>
                <thead>
                  <tr>
                    <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                      Estimate No
                    </td>
                    <td>:</td>
                    <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                      {data.estimateNo ? data.estimateNo : ""}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{ textAlign: "right", fontWeight: "bolder" }}
                    >
                      Register No
                    </td>
                    <td>:</td>
                    <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                      {`${data.jobOrder?.vehicle?.registerNo}` ||
                        "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                      Job. No
                    </td>
                    <td>:</td>
                    <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                      {data.jobOrder && data.jobOrder?.jobNo
                        ? data.jobOrder?.jobNo
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                      Model
                    </td>
                    <td>:</td>
                    <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                      {data.jobOrder?.vehicle?.vehicle ? (
                        <VehicleName
                          modelName={data.jobOrder.vehicle.vehicle.modelName}
                          modelCode={data.jobOrder.vehicle.vehicle.modelCode}
                        />
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                      ServiceType
                    </td>
                    <td>:</td>
                    <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                      {data.serviceType || "-"}
                    </td>
                  </tr>
                  {
                    data.serviceType == "Accidental" && (
                      <tr>
                        <td
                          style={{ textAlign: "right", fontWeight: "bolder" }}
                        >
                          claim status
                        </td>
                        <td>:</td>
                        <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                          {`${data.claimStatus == true ? "Yes" : "No"}` || "-"}
                        </td>
                      </tr>
                    )
                  }
                  {data.claimStatus && (
                    <>
                      <tr>
                        <td
                          style={{ textAlign: "right", fontWeight: "bolder" }}
                        >
                          Claim Type
                        </td>
                        <td>:</td>
                        <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                          {data.claimType || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ textAlign: "right", fontWeight: "bolder" }}
                        >
                          Insurer
                        </td>
                        <td>:</td>
                        <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                          {data.insurer?.name || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{ textAlign: "right", fontWeight: "bolder" }}
                        >
                          Surveyor
                        </td>
                        <td>:</td>
                        <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                          {(() => {
                            if (!data.survivor || !data.survivor.name) return "";
                            const phone = data.survivor.contacts?.[0]?.phone || data.survivor.CustomerPhone?.[0]?.mobileNo || data.survivor.CustomerPhone?.[0]?.phone || data.survivor.mobileNo || data.survivor.phone || "";
                            return `${data.survivor.name}${phone ? ` - ${phone}` : ""}`;
                          })()}
                        </td>
                      </tr>
                    </>
                  )}
                </thead>
              </table>
            </Col>
            <Col span={16}>
              <div style={{ margin: "1rem" }}>
                <Row>
                  <Col span={10}>
                    <table>
                      <thead>
                        <tr>
                          <img style={{ width: "170px", height: "120px" }} src={data?.jobOrder?.vehicle?.color?.url ? data?.jobOrder?.vehicle?.color?.url : vehicleLogo} alt="" />
                        </tr>
                        {/* <tr>
                                                    <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Kms</td>
                                                    <td>:</td>
                                                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.kms ? data.kms : "-"}</td>
                                                </tr> */}
                      </thead>
                    </table>
                    <Row>
                      <div
                        style={{
                          border: "0.1px solid rgba(0, 0, 0, 0.3)",
                          borderRight: "1px solid rgba(0, 0, 0, 0.3)",
                          borderRadius: ".2rem",
                          margin: ".10rem",
                          marginTop: "1.3rem",
                        }}
                      >
                        <Row>
                          <h1
                            style={{ textAlign: "center", marginTop: ".5rem" }}
                          >
                            Status :{data.estimateStatus && data.estimateStatus}
                          </h1>
                        </Row>
                      </div>
                    </Row>
                  </Col>
                  <Col span={14}>
                    <Row>
                      <Col span={12}>
                        <table>
                          <thead>
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Customer
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.jobOrder?.customer &&
                                  data.jobOrder?.customer.name
                                  ? data.jobOrder?.customer.name
                                  : ""}
                              </td>
                            </tr>
                            {/* <tr>
                                                    <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Service Type</td>
                                                    <td>:</td>
                                                    <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.serviceType && data.serviceType}</td>
                                                </tr> */}
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Mechanic
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.jobOrder?.mechanic &&
                                  data.jobOrder?.mechanic.profile
                                  ? data.jobOrder?.mechanic.profile.employeeName
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Service No
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.jobOrder?.serviceNo}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Kms
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.jobOrder?.kms}
                              </td>
                            </tr>
                            {/* <tr>
                                                            <td style={{ textAlign: 'right', fontWeight: 'bolder' }}>Date</td>
                                                            <td>:</td>
                                                            <td style={{ textAlign: 'left', paddingLeft: '.5rem' }}>{data.createdAt && moment(new Date()).format("DD-MM-YYYY")}</td>
                                                        </tr> */}
                          </thead>
                        </table>
                      </Col>
                      <Col span={12}>
                        <table>
                          <thead>
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Date
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.createdAt &&
                                  moment(data.createdAt).format("DD-MM-YYYY")}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bolder",
                                }}
                              >
                                Time
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: ".5rem",
                                }}
                              >
                                {data.createdAt &&
                                  moment(data.createdAt).format("hh:mm A")}
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </Col>
                    </Row>
                    <div
                      style={{
                        border: "0.1px solid rgba(0, 0, 0, 0.3)",
                        borderRadius: ".2rem",
                        margin: "3.4rem",
                        marginTop: "3.0rem",
                      }}
                    >
                      <Row>
                        <h1 style={{ textAlign: "center", marginTop: ".5rem" }}>
                          Estimate Amount:
                          {data.estTotalAmount ? data.estTotalAmount : "-"}{" "}
                          &nbsp;
                          <Popover
                            placement="bottom"
                            content={
                              <div>
                                {data.labourCharge > 0 && (
                                  <p>Labour Charge:{data.labourCharge}</p>
                                )}
                                {data.partCharge > 0 && (
                                  <p>Part Charge:{data.partCharge}</p>
                                )}
                                {data.consumableCharge > 0 && (
                                  <p>Consumable Charge:{data.consumableCharge}</p>
                                )}
                                {data.cgstAmount && data.sgstAmount && (
                                  <p>Tax:{data.cgstAmount + data.sgstAmount}</p>
                                )}
                                {data.totalDiscount > 0 && (
                                  <p>Discount:{data.totalDiscount}</p>
                                )}
                              </div>
                            }
                          >
                            <InfoCircleOutlined />
                          </Popover>
                        </h1>
                      </Row>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: ".5rem",
                      }}
                    >
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`/job_status/${data?.jobOrder?.id}?edit=true`}
                        className="linkylink"
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        Tracking URL
                      </a>
                      <Divider type="vertical" />
                      {modify ? (
                        (data.estimateStatus === "PENDING" || data.estimateStatus === "PARTIALLY APPROVED" || data.estimateStatus === "Claim Initiated" || data.estimateStatus === "Surveyor Appointed") && (
                          <span
                            onClick={(event) => {
                              event.stopPropagation();
                              history.push({
                                pathname: `/autoadmin/estimate/${data.id}?edit=true`,
                                state: {
                                  gst: gst,
                                },
                              });
                            }}
                            className="linkylink"
                            style={{ marginRight: "5px" }}
                          >
                            Modify
                          </span>
                        )
                      ) : (
                        <span></span>
                      )}
                      <Divider type="vertical" />
                      {printAccess ? (
                        data.id && (
                          <span
                            className="linkylink"
                            style={{ cursor: "pointer" }}
                            onClick={(event) => {
                              handleDownloadPDF(data, event);
                            }}
                          >
                            Download PDF
                          </span>
                        )
                      ) : (
                        <span></span>
                      )}
                      <Divider type="vertical" />
                      {deleteAccess ? (
                        <Popconfirm
                          title="Do you want to delete this Job Order?"
                          okText="Yes"
                          cancelText="No"
                          onCancel={(event) => {
                            event.stopPropagation();
                          }}
                          onConfirm={(event) => {
                            event.stopPropagation();
                            deleteData(data.id);
                            data.id && data.id;
                          }}
                        >
                          <span
                            onClick={(event) => event.stopPropagation()}
                            className="linkylink"
                          >
                            Delete
                          </span>
                        </Popconfirm>
                      ) : (
                        <span></span>
                      )}
                      {!modify && !deleteAccess && !printAccess ? (
                        <Text strong disabled>
                          No Actions Given
                        </Text>
                      ) : (
                        <span></span>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      ),
    },
  ];

  return (
    <div id="estimate">
      <Table
        rowKey={(record) => record.id}
        pagination={pagination}
        columns={column}
        tableLayout="auto"
        style={{ cursor: "pointer" }}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () => {
            history.push({
              pathname: `/autoadmin/estimate/${record.id}`,
              state: {
                gst: gst,
              },
            });
          },
        })}
        loading={spinner}
      />
    </div>
  );
};
export default withRouter(EstimateTable);
